module.exports = __webpack_public_path__ + "static/media/PoidsEnlevement.82cf52cb.svg";